import i18n from 'i18n';
import React, { ErrorInfo } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';

interface ErrorBoundaryProps {
	children: React.ReactNode;
}

interface ErrorBoundaryState {
	hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = {
			hasError: false,
		};
	}

	static getDerivedStateFromError(_: Error): ErrorBoundaryState {
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error('ErrorBoundary caught an error:', error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<Container fluid className="p-5" style={{ minHeight: '100%' }}>
					<Row className="justify-content-center align-items-center h-100">
						<Col md={8} lg={6} className="text-center">
							<h1 className="display-4 mb-4">
								{i18n.t('_general:ERROR_RENDERING_HEADER')}
							</h1>
							<p className="lead mb-4">{i18n.t('_general:ERROR_RENDERING')}</p>
							<Button
								variant="primary"
								className="me-2"
								onClick={() => window.location.reload()}
							>
								{i18n.t('_general:ERROR_RENDERING_REFRESH')}
							</Button>
							<Button
								variant="outline-secondary"
								onClick={() => {
									window.location.href = '/';
								}}
							>
								{i18n.t('_general:ERROR_RENDERING_NAVIGATE_HOME')}
							</Button>
						</Col>
					</Row>
				</Container>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
